<template>
<div class="page">
  <ClientsSectionTabs action-text="+ Добавить менеджера" action-permission="add_manager" @action="setDialogCreateShow(true)" />

  <div v-if="!inClientsSection" class="row">
    <div class="col-10 d-flex align-center">
      <h1 class="font-lg">Менеджеры</h1>
    </div>
    <div class="col-2 d-flex align-center" v-if="$store.getters['auth/isAllowed']('add_manager')">
      <v-btn class="ml-auto d-sm-none" color="primary" small fab @click="setDialogCreateShow(true)">
        <v-icon small>mdi-account-plus</v-icon>
      </v-btn>
      <v-btn class="ml-auto d-none d-sm-block" color="primary" fab @click="setDialogCreateShow(true)">
        <v-icon small>mdi-account-plus</v-icon>
      </v-btn>
    </div>
  </div>

  <div v-if="corpFilterId" class="mb-3">
    <v-chip close color="primary" outlined @click:close="clearCorpFilter">
      Корп: {{ corpFilterName || `№${corpFilterId}` }}
    </v-chip>
  </div>

  <div class="row">
    <div class="col-12 tab">
      <div class="tab__header">
        <v-tabs
          v-model="currentTab"
          active-class="active_tab"
          slider-size="2"
          :color="barColor"
          @change="onTabChange"
        >
          <v-tab
            v-for="(item,idx) in tabs"
            :key="idx"
            class="item"
          >
            {{item.title}}
          </v-tab>
        </v-tabs>
      </div>

      <v-tabs-items v-model="currentTab" class="tab__content">
        <v-tab-item
          v-for="(item,idx) in tabs"
          :key="idx"
        >
          <component :is="item.component" :chartData="chartdata" @createGraph="createGraph"/>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
  <ManagerCreateModal/>
</div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ClientsSectionTabs from '@/components/clients/ClientsSectionTabs.vue';
import { allowedClientsSectionTabs } from '@/common/constants/clientsSection';
import { COLORS } from '@/common/constants/colors';
import ManagerCreateModal from '@/components/managers/ManagerCreateModal';
import ManagersTable from '@/components/managers/table/ManagersTable.vue';
import ManagersGraph from '@/components/managers/Graph/ManagersGraph.vue';
import { TEST_TYPES_COLORS } from '@/common/constants/testTypes';
import api from '@/common/api';

export default {
  name: 'Managers',
  metaInfo: {
    title: 'Менеджеры',
  },
  components: {
    ClientsSectionTabs,
    ManagersGraph,
    ManagerCreateModal,
    ManagersTable,
  },
  data: () => ({
    colors: COLORS,
    corpFilterName: '',
    sheet: false,
    remainsOfTests: false,
    usedTotal: true,
    currentTab: 0,
    tabs: [
      {
        name: 'table',
        title: 'Таблица',
        component: 'ManagersTable',
      },
      {
        name: 'graph',
        title: 'График',
        component: 'ManagersGraph',
      },
    ],
    dataSets: [
      // {
      //   label: 'ММИЛ',
      //   backgroundColor: 'red',
      //   select: true,
      //   data: [215, 189, 42, 167, 203, 138],
      // },
      // {
      //   label: 'Невербальная логика',
      //   select: true,
      //   backgroundColor: '#483CB9',
      //   data: [228, 37, 192, 105, 249, 68, 161, 93, 17, 206, 134, 179],
      // },
      // {
      //   label: 'Числовая логика',
      //   select: true,
      //   backgroundColor: '#483CB9',
      //   data: [83, 147, 232, 56, 198, 111, 29, 164, 225, 72, 139, 246],
      // },
      // {
      //   label: 'Минимульт',
      //   select: true,
      //   backgroundColor: '#483CB9',
      //   data: [49, 176, 103, 218, 87, 152, 234, 61, 129, 195, 42, 167],
      // },
      // {
      //   label: 'Профнавигатор',
      //   select: true,
      //   backgroundColor: '#483CB9',
      //   data: [162, 95, 231, 78, 144, 27, 189, 53, 216, 119, 76, 203],
      // },
    ],

  }),
  computed: {
    // У админа заголовок и кнопка — в шапке раздела «Клиенты»
    inClientsSection() {
      return allowedClientsSectionTabs(this.$store).length > 0;
    },
    ...mapGetters({
      selected: 'users/managers/selected',
      managerStats: 'users/managers/statsManager',
      managersFilter: 'users/managers/filter',
    }),
    // Фильтр по корпу: ?corp_client=ID, показывается чипом «Корп: …»
    corpFilterId() {
      return this.managersFilter.corp_client || '';
    },
    activeTabFromQuery() {
      return this.$route.query.tab;
    },
    barColor: () => '#483CB9',
    chartdata: {
      get() {
        return {
          labels: ['All'],
          datasets: this.dataSets
        };
      },
      set(val) {
        return {
          datasets: val
        };
      }
    },
  },
  watch: {
    corpFilterId: {
      immediate: true,
      async handler(id) {
        this.corpFilterName = '';
        if (!id) return;
        try {
          const corp = await api.get(`/users/corp_clients/${id}/`);
          if (String(this.corpFilterId) === String(id)) this.corpFilterName = corp.company || '';
        } catch (e) {
          this.corpFilterName = '';
        }
      },
    },
    activeTabFromQuery: {
      immediate: true,
      handler(tabName) {
        const tabIndex = this.tabs.findIndex(tab => tab.name === tabName);
        if (tabIndex !== -1) {
          this.currentTab = tabIndex;
        }
      }
    },
    managerStats: {
      immediate: true,
      deep: true,
      handler(stats) {
        this.createGraph(stats);
      }
    },
    currentTab: {
      immediate: true,
      deep: true,
      handler(newTab, oldTab) {
        if (oldTab === 1 && newTab === 0) {
          this.clearFilterAll();
        }
      }
    }
  },
  methods: {
    ...mapMutations({ resetCorpFilter: 'users/managers/setFilterCorpClient' }),
    ...mapActions({
      setSelected: 'users/managers/setSelected',
      setDialogCreateShow: 'users/managers/setDialogCreateShow',
      clearFilterAll: 'users/managers/clearFilterAll',
      setCorpClientFilter: 'users/managers/setCorpClientFilter',
    }),
    clearCorpFilter() {
      this.setCorpClientFilter('');
    },
    updateActiveTabFromQuery() {
      if (this.$route.query.tab) {
        const tabIndex = this.tabs.findIndex(tab => tab.name === this.activeTabFromQuery);
        if (tabIndex !== -1) {
          this.currentTab = tabIndex;
        }
      } else {
        this.$router.push({
          query: {
            ...this.$route.query,
            tab: 'table'
          }
        });
      }
    },
    onTabChange(tabIndex) {
      if (this.activeTabFromQuery) {
        const tab = this.tabs[tabIndex];
        if (tab) {
          this.$router.push({
            query: {
              ...this.$route.query,
              tab: tab.name
            }
          });
        }
      }
    },
    createGraph(val) {
      if (val.tests.length > 0) {
       this.dataSets = val.tests.map((test) => {
         const color = test.color ? test.color : (TEST_TYPES_COLORS[test.test_code] || '#483CB9');
         return {
           label: test.test_name,
           backgroundColor: color,
           borderColor: color,
           select: true,
           data: [test.count, 0],
         };
       });
      } else {
        this.dataSets = [];
      }
      // {
      //
      // },
    }
  },
  mounted() {
    this.updateActiveTabFromQuery();
  },
  beforeDestroy() {
    this.setSelected(null);
    // Фильтр по корпу действует только на этой странице: иначе он попадёт в выпадающие списки и выгрузки других экранов
    this.resetCorpFilter('');
  },
};
</script>
<style lang="scss" scoped>
.tab {
  display: flex;
  flex-direction: column;
  gap: 16px;

  & .tab__header {
    background: white;
    padding: 16px 24px;

    & .active_tab.item {
      color: #483CB9;
      font-weight: 600;

      &:before {
        opacity: 0;
        display: none;
      }

      :after {
        display: none;
      }
    }

    & .item {
      color: #818181;
      text-transform: capitalize;
      font-size: 14px;

      &:before {
        opacity: 0;
        display: none;
      }
    }
  }
}

</style>
